import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { AdminChangelogEntry } from "@/lib/api/changelog";

function dateLabelFor(entry: AdminChangelogEntry): string {
  if (entry.date_label) return entry.date_label;
  const iso = entry.published_at ?? entry.created_at;
  try {
    return format(new Date(iso), "MMM yyyy");
  } catch {
    return "";
  }
}

export const columns: ColumnDef<AdminChangelogEntry>[] = [
  {
    accessorKey: "title",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Title" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col">
        <span className="font-medium">{row.original.title}</span>
        {row.original.subtitle && (
          <span className="text-xs text-muted-foreground">
            {row.original.subtitle}
          </span>
        )}
      </div>
    ),
  },
  {
    accessorKey: "date_label",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date label" />
    ),
    cell: ({ row }) => (
      <span className={row.original.date_label ? "" : "text-muted-foreground"}>
        {dateLabelFor(row.original)}
        {!row.original.date_label && " (auto)"}
      </span>
    ),
  },
  {
    accessorKey: "role_ids",
    header: "Roles",
    cell: ({ row }) => (
      <span className="text-sm text-muted-foreground">
        {row.original.role_ids.length} role
        {row.original.role_ids.length === 1 ? "" : "s"}
      </span>
    ),
  },
  {
    accessorKey: "is_published",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <Badge variant={row.original.is_published ? "default" : "secondary"}>
        {row.original.is_published ? "Published" : "Draft"}
      </Badge>
    ),
  },
  {
    accessorKey: "view_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Views" />
    ),
    cell: ({ row }) => row.original.view_count ?? 0,
  },
];
